;(function($, window, document){
    window.FaqAnchor = Me.view.extend({
        options: {

        },

        initialize: function() {
            _.bindAll(this, 'scrollToAnchor');
            this.addEvents();

        },
        addEvents: function() {
            this.$('a').on('click', this.scrollToAnchor);
        },
        scrollToAnchor: function(e){
            Me.dispatch.emit('faq.scroll',this, {anchor: $(e.currentTarget).attr('href').replace('#','')});
        }
    });
}(jQuery, window, document));
